module.exports = "/_next/static/videos/step1-1a4635dad01faaf26b0144eb6cdc1134.mp4";